import {Component} from 'react';
import CareerInput from '../shared-components/career_input';
import CareerChangeModal from './change_career_modal';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { resetPicturesForChanges } from './objects/reset_pictureInfo_for_changes';
import {createIconTableObj} from './objects/create_icon_table_obj';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { calculateJobSalary } from '../../objects/AssetsExpenses/calculate_job_salary';
import ReviewCancelPendingJob from './review_cancel_pending_job_modal';
import InformationModal from '../shared-components/information_modal';
import ConfigFile from '../../datasets/config_file';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';

class ChangeCareer extends Component {
  
    constructor(props) {
        super(props);
        this.gameInfo = this.props.gameInfo();
        this.state = {
            headers: setHeadersForFetch(),
            openCareerChangeModal: false,
            openInformationModal: false,
            conditionLoading: true,
            openNotificationModal: false,
            conditionList: null,
            rerender: false,
            subProcess: "changeCareer",
            environment: Config.dataURL.currentEnv,
        }
        this.careerObj = {};
        this.openJobPendingPendingJobModal = false;
        this.nextProcess = "SelectJob";
        this.conditionsData = "";
        this.initialProcessing();
    }    

    initialProcessing(){
        if (this.gameInfo.gameData.pendingJob  &&
            this.gameInfo.gameData.pendingJob.jobStartDate ){
            this.nextProcess = "PendingJob";
            this.openJobPendingModal = true;
        }else{
            this.loadConditions();
            this.getSkillSurvey();
        }
    }
        
    loadConditions()
    {
        const funcName = "eventConditionsList";
        const urlParm = "?triggeredByList=monthly,jobChange";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.conditionsList = output.body;
                    this.setState({rerender: true})
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
        });
    }
    
    getSkillSurvey(){
        let skillsSurveyString = sessionStorage.getItem('skillsInterestsInput');
        let skillsSurveyArr = [];
        if (skillsSurveyString === null){
             skillsSurveyArr = this.gameInfo.gameData.skillSurvey;
             skillsSurveyString = skillsSurveyArr.join();
             sessionStorage.setItem('skillsInterestsInput', skillsSurveyString);
                }
    }
   
    render() {
        let jobName = "";
        if (this.gameInfo.gameData.jobInfo.jobName){
            jobName = this.gameInfo.gameData.jobInfo.jobName;
        }
        
    return <>
            {this.nextProcess === "PendingJob" ?
                <ReviewCancelPendingJob
                    show={this.openJobPendingModal} 
                    onClose={(pendingAction) => this.closeCareerModal(pendingAction)} 
                    gameInfo = {() => this.props.gameInfo()}
                    setGameInfo = {(value, propertyName) => this.props.setGameInfo(value, propertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                />
            :
                null
            }

            {this.nextProcess === "ChangeJob" ?
                <CareerChangeModal 
                    show={this.state.openCareerChangeModal} 
                    conditionList = {this.conditionsList}
                    onClose={() => this.closeCareerModal("CareerChange")} 
                    onConfirmCareerChange={(careerObj) => this.onConfirmCareerChange(careerObj)}
                    gameInfo = {() => this.props.gameInfo()}
                    setGameInfo = {(value, propertyName) => this.props.setGameInfo(value, propertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                   />
            :
                null
            }

            {this.nextProcess === "InformationModal"  ?
                <InformationModal   
                    show={this.state.openInformationModal}
                    infoCode={this.informationCode}
                    onClose={() => this.closeInformationModal()}
                />
            :
                null
            }
               
            <CareerInput 
                    onSelected={() => this.onCareerSelected()} 
                    onOpen={() => this.onOpen()}
                    currentJobName={jobName}
                    currentGameDate = {this.gameInfo.gameData.currentGameDate}
                    startGameDate = {this.gameInfo.gameData.startGameDate}
                    fromProcess = "GameView"
                    processError = {(errorObj) => this.props.processError(errorObj)}
                    />
     
        </>
    }

    onOpen(){
        //  this is not required for this process but is required in getting started 
    }

    onCareerSelected() {
        this.nextProcess = "ChangeJob";
        this.setState({openCareerChangeModal: true});
    }
   
    closeCareerModal(modalType) {
        switch(modalType){
            case "CareerChange":
                this.nextProcess = "";
                this.setState({openCareerChangeModal: false});
                break;
            case "PendingJobCancelled":
                this.openPendingJobModal = false;
                this.openInformationDisplayModal();
                break;
            case "PendingJobReviewed":
                this.props.onNavigate("game-choices");
                break;
            default:
                break;
        }
    }

    openInformationDisplayModal(){
         this.nextProcess = "InformationModal";
         this.informationCode = "CancelPendingJob";
         this.setState({openInformationModal: true});
    }

    closeInformationModal(){
        this.props.onNavigate("game-choices");
    }
    
    onConfirmCareerChange(careerObj) {
        this.careerObj = careerObj;
        this.setState({openCareerChangeModal: false});
        this.collegeRequired = careerObj.requiresCollege;
        this.updatePictureInfo();
        this.updateIconTable();
        if (ConfigFile.general.eventTracker === true && this.collegeRequired !== true){
            this.saveEventTracker();
        }
        this.setBodyObj();
        this.updateCareerInfo();
        this.props.setGameInfo(this.gameInfo.gameData, 'gameData');
        if (this.collegeRequired === true){
            this.props.onNavigate("game-choices");
        }else{
            this.props.onChangeComplete();
            this.props.onNavigate("status-display");
        }
    }

    updateIconTable(){
        //  check to see if there is a goodNews icon for a job that is not
        //  the new job and if there is one, delete it
        if (this.collegeRequired === true){
            let firstTimeInd = {firstTimeText: true, careerName: this.careerName};
            if (!this.gameInfo.gameData.iconTable){
                this.gameInfo.gameData.iconTable = [];
            }
            this.gameInfo.gameData.iconTable = createIconTableObj("pendingJob", 
                this.gameInfo.gameData.iconTable, firstTimeInd); 
        }
    }
      
    setBodyObj(){
        if (this.collegeRequired === true){
            this.gameInfo.gameData.conditionsTable = this.careerObj.conditionsTable;
            const newPendingJobObj = this.careerObj.pendingJobObj;
            newPendingJobObj.pictureInfo = this.newJobPictureInfo;
            this.addToPrevJobArr();
            newPendingJobObj.jobInfo = {...newPendingJobObj.jobInfo, prevJobArr: this.prevJobArr};
            this.gameInfo.gameData.pendingJob = newPendingJobObj;
        }else{
            this.changeGameData();
        }
        let moodPointsIncrease = this.careerObj.moodPoints;
        this.gameInfo.gameData.currentMoodPoints = 
            (+this.gameInfo.gameData.currentMoodPoints + +moodPointsIncrease).toString();
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
       
        this.bodyObj = {
            "jobInfo": this.gameInfo.gameData.jobInfo, 
            "loanTable": this.gameInfo.gameData.loanTable,
            "assetTable": this.gameInfo.gameData.assetTable,
            "expenseTable": this.gameInfo.gameData.expenseTable,
            "conditionsTable": this.gameInfo.gameData.conditionsTable,
            "currentMoodPoints": this.gameInfo.gameData.currentMoodPoints,
            "pendingJob": this.gameInfo.gameData.pendingJob,
            "iconTable": this.gameInfo.gameData.iconTable
        }
    }

    changeGameData(){
        const newCareerID = sessionStorage.getItem("careerChoice");
        const newHealthInsInd = sessionStorage.getItem("jobHealthInsInd");
        const newJobRank = sessionStorage.getItem("jobRank");
        const newNbrYearsCollege = this.careerObj.nbrYearsCollege;
        this.addToPrevJobArr();
        const jobInfo = {careerID: newCareerID, healthInsInd: newHealthInsInd, 
            jobRank: newJobRank, nbrYearsCollege: newNbrYearsCollege, 
            nbrSkillSurvey: this.gameInfo.gameData.jobInfo.nbrSkillSurvey,
            jobStartDate: this.gameInfo.gameData.currentGameDate,
            prevJobArr: this.prevJobArr};
        this.gameInfo.gameData.jobInfo = jobInfo;
        this.gameInfo.gameData.assetTable = this.careerObj.assetTable;
        this.gameInfo.gameData.expenseTable = this.careerObj.expenseTable;
        this.gameInfo.gameData.loanTable = this.careerObj.loanTable;
        this.gameInfo.gameData.conditionsTable = this.careerObj.conditionsTable;
        this.gameInfo.gameData.pendingJob = {};

    }

    addToPrevJobArr(){
        this.prevJobArr = [];
        if (this.gameInfo.gameData.jobInfo.prevJobArr ){
            this.prevJobArr = this.gameInfo.gameData.jobInfo.prevJobArr;
        };
        const currentMonthlySalary = calculateJobSalary
        let previousJobObj = {previousJobName: this.previousCareerName, 
            jobEndDate: this.gameInfo.gameData.currentGameDate,
            monthlySalary: currentMonthlySalary};
        this.prevJobArr.push(previousJobObj);
    }
            
    updateCareerInfo()
    {  
        const funcName = "updateCareerInfo";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'PUT', headers: this.state.headers,
            body: JSON.stringify(this.bodyObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            // update of gameData was successful
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                            this.props.processError(errorObj);
                        }
                    });
                };
            });
    }

    updatePictureInfo(){
        let careerID = sessionStorage.getItem("careerChoice");
        this.careerName = sessionStorage.getItem("careerName");
        this.previousCareerName = sessionStorage.getItem("previousJobName");
        let jobPictureImg = sessionStorage.getItem("careerPictureImg");
        let careerPictureImg = './assets/Jobs/' + jobPictureImg;
        let careerBackground = sessionStorage.getItem("careerBackgroundImg")
        let careerBackgroundImg = "./assets/jobBackground/" + careerBackground;
        let jobMaxSalary = sessionStorage.getItem("careerMaxSalary");
        let level2Title = sessionStorage.getItem("careerLevel2Title");
        let level3Title = sessionStorage.getItem("careerLevel3Title");
        let jobPictureInfo={jobMaxSalary: jobMaxSalary, jobLevel2: level2Title, jobLevel3: level3Title};
        this.newJobPictureInfo = "";
        if (this.collegeRequired === true){
            this.newJobPictureInfo = {careerID: careerID, careerName: this.careerName, 
                careerPictureImg: careerPictureImg, careerBackgroundImg: careerBackgroundImg,
                ...jobPictureInfo};
        }else{
            let pictureInfo = {...this.gameInfo.pictureInfo, ...jobPictureInfo}
            this.gameInfo.pictureInfo = resetPicturesForChanges("career", pictureInfo,
                careerID, this.careerName, careerPictureImg, careerBackgroundImg);
            this.props.setGameInfo(this.gameInfo.pictureInfo, 'pictureInfo');
        }
    }

    saveEventTracker(){
        const jobChangeInfo = {changeMade: "job", previous: this.previousCareerName, new: this.careerName,
            cashChg: 0,
            conditionsTable: this.careerObj.conditionsTable,
            assetTable: this.careerObj.assetTable, 
            expenseTable: this.careerObj.expenseTable,
            loanTable: this.gameInfo.gameData.loanTable, 
            moodPoints: this.careerObj.moodPoints,};
     
        const dataObject = createEventTrackerUpdateObject("ChangeGameChoices", "ChangeCareer",
            this.gameInfo.gameData, jobChangeInfo, this.gameInfo.creditCardInfo);
        let urlParm = "";
        const funcName = "saveEventTracker";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
                method:'post',
                headers: this.state.headers,
                body: JSON.stringify(dataObject)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                           // update of event tracker was successful
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: dataObject,
                                silentAlert: true};
                            this.props.processError(errorObj);
                        }
                    });
                };
            });
    }

    
}
export default ChangeCareer;